var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:_vm.cellClasses,attrs:{"colspan":_vm.colspan,"data-row":_vm.index,"data-name":_vm.cellNameIndex}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.formattedValue)+" ")]},null,{ value: _vm.formattedValue })],2)}
var staticRenderFns = []

export { render, staticRenderFns }